// extracted by mini-css-extract-plugin
export default {"attributes":"AttributeSections_attributes__aaarO"};